import React from 'react';
import { IconButton, Typography, useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Delete } from '@mui/icons-material';
import { formatCurrency, safelyParseFloat, safelyParseInt } from '@/utils/constants';
import DataGridNumericFormat from '@/components/table/DataGridComponents/DataGridNumericFormat';
import DataGridYearPicker from '@/components/table/DataGridComponents/DataGridYearPicker';
import useCellModes from '@/hooks/useCellModes';
import { CLIENT_TYPE, DOMESTIC } from '../../CreateNewBusinessForm/validationSchema';
import { useObjectContext } from '@/hooks/useObjectContext';

export const MaterialDamageLocationTable = ({ rows, updateRows, disabled }) => {
	const theme = useTheme();
	const { dealRow } = useObjectContext();

	const isDomestic = dealRow?.[CLIENT_TYPE] == DOMESTIC;

	const columns = [
		{
			field: 'coverage',
			headerName: 'Coverage',
			flex: 0.3,
			minWidth: 150,
			editable: false,
			sortable: false,
			display: 'flex',
			// renderCell: (params) =>
			// 	params.row.year === '' ? (
			// 		<Typography sx={{ color: theme.palette.text.secondary }}>{'Enter year'}</Typography>
			// 	) : (
			// 		params.row.year
			// 	),
			// renderEditCell: (params) => <DataGridYearPicker {...params} />,
		},
		{
			field: 'basisOfSettlement',
			headerName: 'Basis of Settlement',
			flex: 0.5,
			minWidth: 200,
			editable: !disabled,
			sortable: false,
			display: 'flex',
			renderCell: (params) =>
				params.row.basisOfSettlement === '' ? (
					<Typography sx={{ color: theme.palette.text.secondary }}>
						Enter basis of settlement
					</Typography>
				) : (
					params.row.basisOfSettlement
				),
		},
		{
			field: 'fslIndemnity',
			headerName: 'FSL Indemnity Value ($)',
			flex: 0.3,
			minWidth: 150,
			editable: !disabled,
			sortable: false,
			display: 'flex',
			align: 'right',
			headerAlign: 'right',
			renderCell: (params) => {
				if (params.row.coverage === 'Buildings') {
					const value = safelyParseFloat(params.row.fslIndemnity ?? 0);
					if (value > 0) {
						return formatCurrency({ num: value, showDecimal: false });
					} else {
						return (
							<Typography sx={{ color: theme.palette.text.secondary }}>
								Enter FSL indemnity value
							</Typography>
						);
					}
				} else {
					return <></>;
				}
			},
			renderEditCell: (params) => <DataGridNumericFormat {...params} isCurrency={true} />,
		},
		{
			field: 'noOfResidential',
			headerName: 'Number of Residential Units',
			flex: 0.3,
			minWidth: 150,
			editable: !disabled,
			sortable: false,
			display: 'flex',
			align: 'right',
			headerAlign: 'right',
			renderCell: (params) => {
				if (params.row.coverage === 'Buildings') {
					const value = safelyParseInt(params.row.noOfResidential ?? 0);
					return value;
				} else {
					return <></>;
				}
			},
			renderEditCell: (params) => <DataGridNumericFormat {...params} />,
		},
		{
			field: 'sumInsured',
			headerName: 'Sum Insured ($)',
			flex: 0.3,
			minWidth: 150,
			editable: !disabled,
			sortable: false,
			display: 'flex',
			align: 'right',
			headerAlign: 'right',
			renderCell: (params) => {
				const value = safelyParseFloat(params.row.sumInsured ?? 0);
				if (value > 0) {
					return formatCurrency({ num: value, showDecimal: false });
				} else {
					return (
						<Typography sx={{ color: theme.palette.text.secondary }}>Enter sum insured</Typography>
					);
				}
			},
			renderEditCell: (params) => <DataGridNumericFormat {...params} isCurrency={true} />,
		},
	];

	return (
		<DataGrid
			sx={{
				'& .MuiDataGrid-editInputCell': {
					backgroundColor: 'transparent',
				},
			}}
			width='100%'
			processRowUpdate={updateRows}
			rows={rows}
			columns={columns}
			isCellEditable={(params) => {
				if (params.field === 'fslIndemnity' || params.field === 'noOfResidential') {
					return params.row.coverage === 'Buildings' && !disabled;
				}
				return !disabled;
			}}
			// getRowId={(row) => `${row.year}-${row.make}-${row.model}`}
			// checkboxSelection
			// onRowSelectionModelChange={setRowSelectionModel}
			// rowSelectionModel={rowSelectionModel}
			// cellModesModel={cellModesModel}
			// onCellModesModelChange={handleCellModesModelChange}
			// onCellClick={handleCellClick}
			disableRowSelectionOnClick
			disableSelectionOnClick
			disableColumnFilter
			disableColumnSelector
			disableColumnMenu
			hideFooter
		/>
	);
};
